<template lang="html">
  <div  :style="{ 'padding-top': offsetHeight + 'px' }">
  <!-- <div  :style="{ 'padding-top': 100 + 'px' }"> -->
    <van-nav-bar
      :fixed="true"
      title="我收到的礼品卡"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <gift-card-invitation-list
      ref="giftCardInvitationList"
      :slug="slug"
    >
    </gift-card-invitation-list>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar } from 'vant'
import GiftCardInvitationList from '../gift-card-invitation-list.vue'
Vue.use(NavBar)
export default {
  components: {
    GiftCardInvitationList
  },
  data () {
    return {
      slug: '',
      offsetHeight: 0
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace({
        name: `UserCenterIndex`,
        params: {
          slug: this.slug
        }
      })
    }
  },
  mounted () {
    this.slug = this.$route.params.slug,
    this.$nextTick(function() {
      this.offsetHeight = this.$refs.navBar.$el.offsetHeight
    })
  }
}
</script>

<style lang="css" scoped>
</style>
